import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { switchToCustomer } from "../loaders/customer-override";
import { completeMagicLinkSignIn, listenToAuthStateChanges } from "../utils/auth";


function RootLayout() {
  const location = useLocation();

  useEffect(() => {
    completeMagicLinkSignIn();
    listenToAuthStateChanges();
  }, []);

  // Allow switching the active customer on the fly from any page via a
  // `?customer=<name|id>` query param (subject to the user having access).
  useEffect(() => {
    switchToCustomer(new URLSearchParams(location.search).get("customer"));
  }, [location.search]);

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#ffffff", display: "flex", flexDirection: "column" }}>
      <Header />
      <Container className="mt-4" style={{ flex: 1 }}>
        <Outlet />
      </Container>
      <Footer />
    </div>
  );
}

export default RootLayout;
